import cn from 'classnames'
import React, { ReactElement } from 'react'
import mastercardLogoUrl from 'src/assets/images/issuerLogos/mastercard.svg'
import { TranslateFn } from 'src/localization/translate'

import style from './PricingPageHero.style'

const PARTNER_DISPLAY_NAME: Record<string, string> = {
  AMEX: 'American Express',
  CNB: 'City National Bank',
  TCB: 'Texas Capital Bank',
  HSBC: 'HSBC',
  MASTERCARD: 'Mastercard',
}

const PARTNER_LOGO_URL: Partial<Record<string, string>> = {
  MASTERCARD: mastercardLogoUrl,
}

const getPartnerLogoUrl = (partner: string): string => {
  const normalizedPartner = partner.toUpperCase()
  return (
    PARTNER_LOGO_URL[normalizedPartner] ??
    `https://brand-assets.paywithextend.com/${partner.toLowerCase()}/BankLogoIcon.svg`
  )
}

const getPartnerDisplayName = (partner: string): string | undefined =>
  PARTNER_DISPLAY_NAME[partner.toUpperCase()]

interface PricingPageHeroProps {
  className?: string
  translate: TranslateFn
  partner?: string
}

export default function PricingPageHero(
  props: PricingPageHeroProps,
): ReactElement {
  const { className = '', translate, partner } = props

  return (
    <div className={cn('PricingPageHero', className)} css={style}>
      {partner && (
        <div className="PricingPageHero-branding flex-column align-center gap-3 text-primary font-sm font-weight-medium">
          <img
            alt={partner}
            className={cn('BrandPartnership-logo', partner.toLowerCase())}
            src={getPartnerLogoUrl(partner)}
          />
          {getPartnerDisplayName(partner)}
        </div>
      )}
      <div className="PricingPageHero-headingGroup">
        <h2 className="PricingPageHero-heading">
          {translate(
            partner
              ? 'Access your exclusive offer'
              : "Choose the plan that's right for you",
          )}
        </h2>
        <p className="PricingPageHero-copy">
          {translate(
            'Find the right fit for your business. Start free or upgrade to a paid plan to unlock more powerful spend controls and expense tracking features.',
          )}
        </p>
      </div>
    </div>
  )
}
